module.exports = __webpack_public_path__ + "static/media/courses-performance-chart.3b121bfa.svg";